import { render, staticRenderFns } from "./card-register.component.vue?vue&type=template&id=02906a04"
import script from "./card-register.component.vue?vue&type=script&lang=js"
export * from "./card-register.component.vue?vue&type=script&lang=js"
import style0 from "./card-register.component.vue?vue&type=style&index=0&id=02906a04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports